import React from 'react';
import styles from './AdminTable.module.css';
import { EditIcon, TrashIcon } from '../../components/Icons';

function AdminTable({ 
  data = [], 
  columns = [], 
  loading = false, 
  onEdit, 
  onDelete, 
  emptyMessage = '暂无数据',
  showActions = true 
}) {
  if (loading) {
    return (
      <div className={styles.tableContainer}>
        <div className={styles.loading}>
          <div className={styles.spinner}></div>
          <p>加载中...</p>
        </div>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className={styles.tableContainer}>
        <div className={styles.empty}>
          <div className={styles.emptyIcon}>📭</div>
          <p>{emptyMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead className={styles.tableHead}>
            <tr>
              {columns.map((column) => (
                <th 
                  key={column.key} 
                  className={styles.tableHeader}
                  style={{ width: column.width }}
                >
                  {column.label}
                </th>
              ))}
              {showActions && (
                <th className={styles.tableHeader} style={{ width: '120px' }}>
                  操作
                </th>
              )}
            </tr>
          </thead>
          <tbody className={styles.tableBody}>
            {data.map((row, index) => (
              <tr key={row.id || index} className={styles.tableRow}>
                {columns.map((column) => (
                  <td key={column.key} className={styles.tableCell}>
                    {column.render 
                      ? column.render(row[column.key], row) 
                      : row[column.key]
                    }
                  </td>
                ))}
                {showActions && (
                  <td className={styles.tableCell}>
                    <div className={styles.actions}>
                      {onEdit && (
                        <button
                          className={`${styles.actionBtn} ${styles.editBtn}`}
                          onClick={() => onEdit(row)}
                          title="编辑"
                        >
                          <EditIcon size={14} />
                        </button>
                      )}
                      {onDelete && (
                        <button
                          className={`${styles.actionBtn} ${styles.deleteBtn}`}
                          onClick={() => onDelete(row)}
                          title="删除"
                        >
                          <TrashIcon size={14} />
                        </button>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className={styles.tableFooter}>
        <span className={styles.totalCount}>
          共 {data.length} 条记录
        </span>
      </div>
    </div>
  );
}

export default AdminTable;
